// Original destinations preserved from the public link hub; old promotions omitted.
export const socialProfiles = [
  {
    id: 'instagram',
    title: 'Instagram',
    description: 'Find me at @mi.lk.',
    href: 'https://instagram.com/mi.lk',
    affiliate: false,
  },
  {
    id: 'tiktok',
    title: 'TikTok',
    description: 'Follow along at @maradrinksmilk.',
    href: 'https://tiktok.com/@maradrinksmilk',
    affiliate: false,
  },
];

export const socialLinks = [
  {
    id: 'amazon',
    title: 'Amazon storefront',
    description: 'My finds, all in one place.',
    href: 'https://www.amazon.com/shop/influencer-97f7757d',
    affiliate: true,
  },
  {
    id: 'youtube',
    title: 'Subscribe on YouTube',
    description: 'Stay a little longer. Watch along with me.',
    href: 'https://youtube.com/channel/UCfuOFxW3PgXzPpZBYHnE3uA?sub_confirmation=1',
    affiliate: false,
  },
  {
    id: 'lala',
    title: 'Lala Hijab',
    description: 'A little something for your everyday wardrobe.',
    href: 'https://lalahijabs.com/milk',
    affiliate: true,
  },
];
